if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector('span');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            async onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const isImageRequired = window.engravingStore.config.some((field) => field.key === 'image');
                const imageValues = window.engravingStore.getImageValuesById(window.engravingStore.currentVariationId).image;

                if (isImageRequired && !(imageValues && imageValues.inputFile && imageValues.url)) {
                    this.handleErrorMessage('Bitte lade zuerst ein gültiges Bild hoch.');
                    this.resetSubmitState();
                    return;
                }

                let responseEngraving;
                try {
                    responseEngraving = await window.engravingApi.saveEngraving()
                } catch (error) {
                    this.handleErrorMessage(error.message);
                    this.resetSubmitState();
                    return;
                }

                if (
                    isImageRequired &&
                    !(responseEngraving && responseEngraving.image_data && responseEngraving.image_data['result'])
                ) {
                    this.handleErrorMessage('Das Bild konnte nicht übertragen werden. Bitte lade das Bild erneut hoch.');
                    this.resetSubmitState();
                    return;
                }

                const inputValueContainer = document.querySelector('#js--engraving-input-value-container')
                inputValueContainer.innerHTML = ''

                let isEngravingItem = false;

                if (responseEngraving) {
                    for (let i = 0; i < window.engravingStore.config.length; i++) {
                        const currentConfig = window.engravingStore.config[i];

                        if (currentConfig.key !== 'image') {
                            // console.log("responseEngraving", responseEngraving)
                            if (
                                responseEngraving.text_data_shopify &&
                                typeof responseEngraving.text_data_shopify[currentConfig.key] !== 'undefined'
                            ) {

                                inputValueContainer.insertAdjacentHTML('beforeend',
                                    `<input 
                                        type="hidden" 
                                        name="properties[${currentConfig.orderPropId}]" 
                                        value="✓ erfolgreich übermittelt"
                                    />`
                                )
                                isEngravingItem = responseEngraving;

                            } else {
                                    inputValueContainer.insertAdjacentHTML('beforeend',
                                    `<input 
                                        type="hidden" 
                                        name="properties[${currentConfig.orderPropId}]" 
                                        value="Keine Eingabe"
                                    />`)
                                    isEngravingItem = responseEngraving;

                                }

                        } else if (currentConfig.key === 'image') {
                            if (
                                responseEngraving.image_data &&
                                typeof responseEngraving.image_data['result'] !== 'undefined'
                            ) {
                                inputValueContainer.insertAdjacentHTML('beforeend',
                                    `<input 
                                            type="hidden" 
                                            name="properties[${window.engravingStore.getEngravingOrderPropIdByKey('image')}]" 
                                            value="✓ erfolgreich übermittelt"
                                        />`
                                )
                                inputValueContainer.insertAdjacentHTML('beforeend',
                                `<input 
                                        type="hidden" 
                                        name="properties[_${window.engravingStore.getEngravingOrderPropIdByKey('image')}]" 
                                        value="${responseEngraving.image_data['result']}"
                                    />`
                                )
                                inputValueContainer.insertAdjacentHTML('beforeend',
                                    `<input 
                                            type="hidden" 
                                            name="properties[_${window.engravingStore.getEngravingOrderPropIdByKey('image')} Original]" 
                                            value="${responseEngraving.image_data['customerImage']}"
                                        />`
                                )
                                isEngravingItem = responseEngraving;

                            } else {
                                inputValueContainer.insertAdjacentHTML('beforeend',
                                    `<input 
                                            type="hidden" 
                                            name="properties[${window.engravingStore.getEngravingOrderPropIdByKey('image')}]" 
                                            value="Keine Eingabe"
                                        />`
                                )
                            }
                        }
                    }

                    if (isEngravingItem) {
						if (
							responseEngraving.image_data &&
							typeof responseEngraving.image_data['preview'] !== 'undefined'
						) {
							inputValueContainer.insertAdjacentHTML('beforeend',
								`<input 
                                        type="hidden" 
                                        name="properties[${window.engravingStore.getEngravingOrderPropIdByKey('previewImage')}]" 
                                        value="${responseEngraving.image_data['preview']}"
                                    />`
							)
						}
                        inputValueContainer.insertAdjacentHTML('beforeend',
                            `<input 
                                type="hidden" 
                                name="properties[${window.engravingStore.getEngravingOrderPropIdByKey('number')}]" 
                                value="${responseEngraving.id}"
                            />`
                        )
                    }
                }

                this.form = this.querySelector('form');
                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }

                for (let i = 0; i < window.engravingStore.config.length; i++) {
                    const currentConfig = window.engravingStore.config[i];

                    if (currentConfig.key !== 'image') {
                        if (
                            responseEngraving.text_data_shopify &&
                            typeof responseEngraving.text_data_shopify[currentConfig.key] !== 'undefined'
                            // && responseEngraving.text_data_shopify[currentConfig.key].split('; ')[0] !== ''
                        ) {
                            formData.append(
                                `properties[_${currentConfig.orderPropId}]`,
                                responseEngraving.text_data_shopify[currentConfig.key]
                            )
                        }
                        else {
                            formData.append(
                                `properties[_${currentConfig.orderPropId}]`,
                                ''
                            )
                        }
                    }
                }

                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then(async (response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButtonText.classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            this.resetSubmitState()
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            this.resetSubmitState()
                            return;
                        }

                        if (!this.error) {
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                cartData: response,
                            });

                            if(parseInt(responseEngraving['item_id']) === response.variant_id) {
                                const result = await window.engravingApi.updateEngravingBasketItemId({
                                    engravingId : parseInt(responseEngraving['id']),
                                    basketItemId : response.id,
                                    variationId : response.variant_id,
                                    basketId : null // @todo this.getCookie('cart')
                                });
                                window.storageManager?.updateItem('engraving-basket-preview', storage => {
                                    if (!storage) {
                                        storage = {};
                                    }
                                    if (typeof result.svg_data !== 'undefined') {
                                        storage[responseEngraving['id']] = result.svg_data;
                                    }
                                    return storage;
                                })
                            }
                        }
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                {once: true}
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                        this.resetSubmitState()
                    })
                    .catch((e) => {
                        console.error(e);
                        this.resetSubmitState()
                    })
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }

            toggleSubmitButton(disable = true, text) {
                if (disable) {
                    this.submitButton.setAttribute('disabled', 'disabled');
                    if (text) this.submitButtonText.textContent = text;
                } else {
                    this.submitButton.removeAttribute('disabled');
                    this.submitButtonText.textContent = window.variantStrings.addToCart;
                }
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }

            getCookie(name) {
                const cookieString = document.cookie.split(';');
                name = name + '=';

                for (let i = 0; i < cookieString.length; i++) {
                    let cookie = cookieString[i];
                    while (cookie.charAt(0) === ' ') {
                        cookie = cookie.substring(1);
                    }
                    if (cookie.indexOf(name) === 0) {
                        return cookie.substring(name.length, cookie.length);
                    }
                }

                return false;
            }

            resetSubmitState() {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
            }
        }
    );
}
